/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Compare_Row_Agents_AcInputs */

const en_cad_compare_row_agents_ac = /** @type {(inputs: Cad_Compare_Row_Agents_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autodesk AI assistants; APIs like AutoLISP and .NET`)
};

/**
* | output |
* | --- |
* | "Autodesk AI assistants; APIs like AutoLISP and .NET" |
*
* @param {Cad_Compare_Row_Agents_AcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_compare_row_agents_ac = /** @type {((inputs?: Cad_Compare_Row_Agents_AcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Compare_Row_Agents_AcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_compare_row_agents_ac(inputs)
});
export { cad_compare_row_agents_ac as "cad.compare.row_agents_ac" }